var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"profile-info"},[_vm._m(0),_c('div',{staticClass:"profile-name",class:{'big-name': _vm.bigName}},[_vm._v(" "+_vm._s(_vm.userFullName)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-picture"},[_c('img',{staticClass:"user-icon",attrs:{"src":require("../assets/svg/user-solid.svg")}})])
}]

export { render, staticRenderFns }